import { Alert, Box, Snackbar, Tab, Tabs, Typography } from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";
import { useState } from "react";
import BroadcastBuilder from "./BroadcastBuilder";
import BroadcastHistory from "./BroadcastHistory";
import LargeScreenNotice from "../../common/LargeScreenNotice";

const BroadcastPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [snackOpen, setSnackOpen] = useState(false);
  const [historyKey, setHistoryKey] = useState(0);

  const handleSendSuccess = () => {
    setSnackOpen(true);
    setActiveTab(1);
    // Force BroadcastHistory to re-mount and re-fetch
    setHistoryKey((k) => k + 1);
  };

  return (
    <Box sx={{ p: 3 }}>
      <LargeScreenNotice pageKey="broadcast" />
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
        <CampaignIcon sx={{ color: "#9d2362", fontSize: 32 }} />
        <Typography variant="h5" fontWeight={700}>
          Broadcasting Builder
        </Typography>
      </Box>

      <Tabs
        value={activeTab}
        onChange={(_e, v) => setActiveTab(v)}
        sx={{
          mb: 3,
          borderBottom: "1px solid #e0e0e0",
          "& .MuiTab-root.Mui-selected": { color: "#9d2362" },
          "& .MuiTabs-indicator": { backgroundColor: "#9d2362" },
        }}
      >
        <Tab label="New Broadcast" />
        <Tab label="History" />
      </Tabs>

      {activeTab === 0 && (
        <BroadcastBuilder onSendSuccess={handleSendSuccess} />
      )}
      {activeTab === 1 && <BroadcastHistory key={historyKey} />}

      <Snackbar
        open={snackOpen}
        autoHideDuration={6000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackOpen(false)}
          severity="success"
          variant="filled"
        >
          Broadcast queued successfully! Sending is in progress — check the History tab for status.
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BroadcastPage;
